import * as React from "react"
import ExampleHeader from "./ExampleHeader"
import ExampleContent from "./ExampleContent"
import FooterContent from "./Footer"
import Builder from "./BuilderPage"
import { useStateMachine } from "little-state-machine"
import styles from "./HomePage.module.css"
const { useState, useRef, useEffect } = React

const options = {
  rootMargin: "0px 0px",
  threshold: [1],
}

function HomePage({
  location,
  defaultLang,
}: {
  location: {
    search: string
    pathname: string
  }
  defaultLang: string
}) {
  const [showBuilder, toggleBuilder] = useState(false)
  const HomeRef = useRef(null)
  const [isPlayFeature, setFeaturePlay] = useState(false)
  const [isPlayCodeCompare, setCodeComparePlay] = useState(false)
  const [isIsolatePlay, setIsolatePlay] = useState(false)
  const [isCardPlay, setCardPlay] = useState(false)
  const [isPlayRender, setRenderPlay] = useState(false)
  const [formUpdated, setFormUpdated] = useState(false)
  const {
    state: { language },
  } = useStateMachine()
  const { currentLanguage } =
    language && language.currentLanguage
      ? language
      : { currentLanguage: defaultLang }

  useEffect(() => {
    if (location.search.startsWith("?goToDemo")) {
      setTimeout(() => {
        HomeRef.current.scrollIntoView({ behavior: "smooth" })

        if (location.search.startsWith("?goToDemo&updated=true")) {
          setFormUpdated(true)
        }
      }, 100)
    }

    // if (!IntersectionObserver) {
    //   setFeaturePlay(true)
    //   setCodeComparePlay(true)
    // }

    // const featureList = document.querySelector("#featureLast")
    // const codeComparison = document.querySelector("#codeComparison")
    // const rendering = document.querySelector("#rendering")
    // const isolate = document.querySelector("#isolate")
    // const card = document.querySelector("#card")

    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach((entry) => {
    //     if (entry.isIntersecting) {
    //       if (entry.target === featureList && !isPlayFeature) {
    //         setFeaturePlay(true)
    //       }
    //       if (entry.target === codeComparison && !isPlayCodeCompare) {
    //         setCodeComparePlay(true)
    //       }
    //       if (entry.target === rendering && !isPlayRender) {
    //         setRenderPlay(true)
    //       }
    //       if (entry.target === isolate && !isIsolatePlay) {
    //         setIsolatePlay(true)
    //       }
    //       // if (entry.target === card && !isCardPlay) {
    //       //   setCardPlay(true)
    //       // }
    //     }
    //   })
    // }, options)

    // // observer.observe(featureList)
    // // observer.observe(codeComparison)
    // // observer.observe(rendering)
    // // observer.observe(isolate)
    // // observer.observe(card)

    // return () => observer.disconnect()
  }, [])

  return (
    <div className={styles.root}>
      {showBuilder && (
        <Builder
          showBuilder
          toggleBuilder={toggleBuilder}
          HomeRef={HomeRef}
          defaultLang={defaultLang}
        />
      )}

      <ExampleHeader
        isCardPlay={isCardPlay}
        homeRef={HomeRef}
        defaultLang={defaultLang}
      />

      <ExampleContent
        isPlayCodeCompare={isPlayCodeCompare}
        currentLanguage={currentLanguage}
      />
      
      <div ref={HomeRef} />
      
      <FooterContent currentLanguage={currentLanguage} />
    </div>
  )
}

export default React.memo(HomePage)
